export const appendSvgSprites = (sprites) => {
    sprites.map(content => {
        const sprite = new window.DOMParser().parseFromString(content, 'image/svg+xml').querySelectorAll('symbol[id]');
        const spriteNodes = Array.from(sprite);
        const svgSpritesRoot = document.body.querySelector('svg#svgSpritesRoot');
        const filteredNodes = Array.from(svgSpritesRoot.childNodes).filter(node => !spriteNodes.some(it => it.id === node.id));
        svgSpritesRoot.textContent = '';
        svgSpritesRoot.append(...filteredNodes, ...spriteNodes);
    });
};
export const createSvgSpritesConainer = () => {
    if (document.body.querySelector('svg#svgSpritesRoot')) {
        return;
    }
    document.body.insertAdjacentElement('afterbegin', new window.DOMParser()
        .parseFromString('<?xml version="1.0" encoding="UTF-8"?> <svg xmlns="http://www.w3.org/2000/svg" style="display:none" id="svgSpritesRoot"></svg>', 'image/svg+xml')
        .querySelector('svg'));
};
